<template>
  <div class="crud_module--view_details_modal">
    <div class="content">
      <div class="row" v-for="(row,index) in setting" :key="index">
        <div class="item" v-for="(item,j) in row" :key="j">
          <RelatedInfoDataTable v-if="item.type == 'related_info'" :option="item" :params="getParams(item.params, data)"/>
          <div class="data" v-else-if="item.type != 'tabs' && item.type != 'component'">
            <div class="label">{{ tran(namespace, `${typeof item == "object" ? item.key : item}`) }}</div>
            <div class="value">
              <div class="json" v-if="isJson(getValue(item))">
                <vue-json-pretty
                  :data="JSON.parse(getValue(item))"
                >
                </vue-json-pretty>
              </div>
              <div class="text" v-else>{{ getValue(item) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css';

export default {
  name: "ViewDetailsModal",
  components: {
    VueJsonPretty,
  },
  props: {
    namespace: String,
    setting: {
      type: Array,
      default() {
        return [];
      }
    },
    data: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  methods: {
    getValue(field) {
      // console.log("field: ",field);
      let split = field.value ? field.value?.split(".") : typeof field == "object" ? field?.key?.split(".") :  field?.split(".");
      console.log("split: ",split);
      if(typeof split == "undefined") return;
      if(split.length == 1) return this.data[field];
      let value = this.data;
      console.log("value: ",value);
      // if(split.length > 0) split.unshift(field.key);
      split.map(f=>{
        if(value[f] == null) {
          value = "";
          return;
        };
        value = value[f];
        // console.log(value);
      });
      
      return value;
    },
    isJson(value) {
      console.log(parseInt(value) != NaN);
      if(value === null) return false;
      if(!isNaN(parseInt(value))) return false;
      try{
        JSON.parse(value);
        return true;
      }catch(err) {
        return false;
      }
    },
    getParams(params, data) {
      let obj = {};
      params = params ? params : [];
      params.map(p=>{
        if(data.hasOwnProperty(p)) {
          obj[p] = data[p];
        }
      });
      return obj;
    }
  }
}
</script>

<style lang="scss">
.crud_module--view_details_modal{
  // height: 90vh;
  width: 70vw;
  background: white;
  border-radius: 3px;
  overflow-y: auto;
  height: 90vh;
  .content{
    padding: 20px;
    .row{
      display: flex;
      margin-bottom: 10px;
      .item{
        flex-grow: 1;
        display: flex;
        width: 800px;
        font-size: x-small;
        .label{
          width: 100px;
          min-width: 100px;
        }
        .value{
          min-width: 200px;
          width: 100%;
          border: 1px solid gray;
          background-color: #E6E6E6 !important;
          padding: 3px 5px;
          .json{
            .vjs-tree.is-root{
              &,.vjs-key,.vjs-value{
                font-size: xx-small;
              }
            }
          }
        }
        &:not(:first-child) {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>